import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public API calls
export const getProfile = async () => {
  const response = await api.get('/profile');
  return response.data.data;
};

export const getTimeline = async () => {
  const response = await api.get('/timeline');
  return response.data.data;
};

export const getSocialLinks = async () => {
  const response = await api.get('/social-links');
  return response.data.data;
};

export const getPickleballPosts = async () => {
  const response = await api.get('/pickleball');
  return response.data.data;
};

export const getDevPostProjects = async () => {
  const response = await api.get('/devpost');
  return response.data.data;
};

export const getInvestments = async () => {
  const response = await api.get('/investments');
  return response.data;
};

export const getEducation = async () => {
  const response = await api.get('/education');
  return response.data.data;
};

export const submitContactForm = async (formData) => {
  const response = await api.post('/contact', formData);
  return response.data;
};

// Fetch Medium articles (RSS feed)
export const getMediumArticles = async (username = 'nishitsadhwani') => {
  try {
    // Using RSS2JSON service to convert Medium RSS to JSON
    const response = await axios.get(`https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@${username}`);
    return response.data.items || [];
  } catch (error) {
    console.error('Error fetching Medium articles:', error);
    return [];
  }
};

// Admin API calls
export const adminLogin = async (email, password) => {
  const response = await api.post('/admin/login', { email, password });
  if (response.data.success && response.data.token) {
    localStorage.setItem('admin_token', response.data.token);
    localStorage.setItem('admin_user', JSON.stringify(response.data.user));
  }
  return response.data;
};

export const adminLogout = () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_user');
};

export const updateProfile = async (profileData) => {
  const response = await api.put('/admin/profile', profileData);
  return response.data.data;
};

export const createTimelineEvent = async (eventData) => {
  const response = await api.post('/admin/timeline', eventData);
  return response.data.data;
};

export const updateTimelineEvent = async (eventId, eventData) => {
  const response = await api.put(`/admin/timeline/${eventId}`, eventData);
  return response.data.data;
};

export const deleteTimelineEvent = async (eventId) => {
  const response = await api.delete(`/admin/timeline/${eventId}`);
  return response.data;
};

export const updateSocialLinks = async (linksData) => {
  const response = await api.put('/admin/social-links', linksData);
  return response.data.data;
};

export const createPickleballPost = async (postData) => {
  const response = await api.post('/admin/pickleball', postData);
  return response.data.data;
};

export const updatePickleballPost = async (postId, postData) => {
  const response = await api.put(`/admin/pickleball/${postId}`, postData);
  return response.data.data;
};

export const deletePickleballPost = async (postId) => {
  const response = await api.delete(`/admin/pickleball/${postId}`);
  return response.data;
};

export default api;